<template>
	<div>
		<h2>{{ $t('labels.general.organization') }}</h2>
		<spinner v-if="model.loading"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.data.name" name="org_name" :placeholder="$t('labels.general.name')"/>
			<input-text v-model="model.data.email" name="org_email" :placeholder="$t('labels.general.email')" rules="email"/>
			<input-textarea v-model="model.data.description" name="org_description" :placeholder="$t('labels.general.description')"/>
			<input-text v-model="model.data.url" name="org_url" :placeholder="$t('labels.general.url')"/>
			<input-text v-model="model.data.location" name="org_location" :placeholder="$t('labels.general.location')"/>
			<input-text v-model="model.data.billing_email" name="org_billing_email" :placeholder="$t('labels.general.billing_email')" rules="email"/>
			<div class="form-group">
				<label>{{ $t('labels.general.picture') }}</label>
				<input type="file" name="file" id="file" @change="filesChange($event.target)" class="picture-file">
				<label for="file">
					<div v-if="pictureB64" class="picture-current">
						<avatar-picture :src="pictureB64" class="big rect"/>
						<div class="picture-remove" @click.stop.prevent="onPictureRemove">X</div>
					</div>
					<div v-else class="picture-empty">Add picture</div>
				</label>
			</div>			
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</div>
</template>

<script>
import generateBase64Picture from '@/utils/generateBase64Picture'
import AvatarPicture from '@/components/avatars/AvatarPicture'
import ApiObject from '@/classes/api/ApiObject'
import FormObject from '@/classes/api/FormObject'
export default {
	components: {
		AvatarPicture
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			model: new ApiObject(),
			form: new FormObject(),
			pictureB64: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			this.model.data.id ? this.editOrganization() : this.addOrganization()
		},
		getOrganization () {
			this.model.loading = true
			this.$api.organizations.get(this, this.user_uid)
				.then(response => {
					this.$log.info('organization', 'organizations.get OK', response)()
					this.model.data = response.body
					if (this.model.data.picture)
						this.downloadFile(this.model.data.picture)
				})
				.catch(error => {
					this.$log.error('organization', 'organizations.get ERROR', error)()
					this.model.error = error
				})
				.finally(() => {
					this.model.loading = false
				})
		},
		addOrganization () {
			this.form.loading = true
			this.$api.organizations.add(this, this.user_uid, this.model.data)
				.then(response => {
					this.$log.info('organization', 'organizations.add OK', response)()
				})
				.catch(error => {
					this.$log.error('organization', 'organizations.add ERROR', error)()
					this.form.error = error
				})
				.finally(() => {
					this.form.loading = false
				})
		},
		editOrganization () {
			this.form.loading = true
			this.$api.organizations.edit(this, this.user_uid, this.model.data)
				.then(response => {
					this.$log.info('organization', 'organizations.edit OK', response)()
				})
				.catch(error => {
					this.$log.error('organization', 'organizations.edit ERROR', error)()
					this.form.error = error
				})
				.finally(() => {
					this.form.loading = false
				})
		},
		getFilePromise (file_uid) {
			return this.$api.files.get(this, this.user_uid, null, file_uid)
				.then(response => {
					this.$log.info('organization', 'files.get OK', response)()
					return response.body
				})
				.catch(error => {
					this.$log.error('organization', 'files.get ERROR', error)()
				})
		},
		getFileMetadataPromise (file_uid) {
			return this.$api.files.getMetadata(this, this.user_uid, null, file_uid)
				.then(response => {
					this.$log.info('organization', 'files.getMetadata OK', response)()
					return response.body
				})
				.catch(error => {
					this.$log.error('organization', 'files.getMetadata ERROR', error)()
				})
		},
		downloadFile (file_uid) {
			Promise.all([this.getFilePromise(file_uid), this.getFileMetadataPromise(file_uid)])
				.then(([picture, metadata]) => {
					this.$log.info('organization', 'downloadFile() OK', picture, metadata)()
					this.model.data.picture = metadata.uid
					this.pictureB64 = generateBase64Picture(picture, metadata.extension)
				})
				.catch(error => {
					this.$log.error('organization', 'downloadFile() ERROR', error)()
				})
		},
		uploadFile (file) {
			this.$api.files.upload(this, this.user_uid, null, file)
				.then(response => {
					this.$log.info('organization', 'files.upload OK', response)()
					this.downloadFile(response.body.uid)
				})
				.catch(error => {
					this.$log.error('organization', 'files.upload ERROR', error)()
				})
		},
		filesChange (target) {
			Array.from(Array(target.files.length).keys())
				.map(i => {
					this.uploadFile(target.files[i])
				})
		},
		onPictureRemove () {
			this.model.data.picture = ''
			this.pictureB64 = null
		}
	},
	mounted () {
		this.getOrganization()
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title('Organization')
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/Organizations.vue